import type { TranscriptElement } from '../types.ts/transcript';

/**
 * Find the index of the transcript element whose timestamp is closest to `ts`.
 *
 * Extracted from the legacy `TranscriptionProcessor.findClosestIndexToTimestamp`
 * (pure logic; operates on an already-resolved transcript-element array).
 *
 * @param elements Final transcript elements to search.
 * @param ts Target timestamp (seconds).
 * @param time Which element timestamp to compare against.
 * @param helperStrategy `'ts_lookbehind'` also considers each element's `ts`
 *   and, when closer, returns the preceding index.
 */
export function findClosestTranscriptIndexToTimestamp(
  elements: TranscriptElement[] | undefined,
  ts: number,
  time: 'ts' | 'end_ts' = 'ts',
  helperStrategy?: 'ts_lookbehind',
): number {
  let closest = 0;
  let minDiff = Infinity;

  elements?.forEach((element, index) => {
    let currTs = element[time];
    if (currTs && element.state !== 'removed' && element.state !== 'cut') {
      const diff = Math.abs(currTs - ts);
      if (diff < minDiff) {
        minDiff = diff;
        closest = index;
      }
    }
    if (helperStrategy === 'ts_lookbehind') {
      currTs = element.ts;
      if (currTs && element.state !== 'removed' && element.state !== 'cut') {
        const diff = Math.abs(currTs - ts);
        if (diff < minDiff) {
          minDiff = diff;
          closest = index - 1;
        }
      }
    }
  });
  return closest;
}
